/**
 * The dot on a space's button (RFC 0330 3c).
 *
 * ONE COMPONENT for the tab and the sidebar row, so the two places a space is
 * drawn cannot come to disagree about what it is doing. The colours are
 * `StatusDot`'s, the same as every other status in the window. Shown on the
 * current space too: a dot that vanished on arrival would read as the work
 * stopping.
 */

import { StatusDot } from '../window/StatusDot'
import type { SpaceActivity } from './spaceRows'

export function SpaceDot({ activity }: { activity: SpaceActivity }) {
  if (!activity) return null
  return (
    <StatusDot
      status={activity}
      title={
        activity === 'asking'
          ? 'An agent is waiting on you'
          : 'An agent is working'
      }
    />
  )
}
